import { styled } from 'styled-components';
import { COLORS, BREAKPOINTS, SPACING } from '../../style';

export const AboutContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md};
`;

export const Who = styled.div`
  h3 {
    font-size: 32px;
    color: ${COLORS.green};
  }

  p {
    font-size: 18px;
    color: ${COLORS.grey};
    text-align: left;
    font-weight: 600;
    line-height: 1.6;
    margin-top: ${SPACING.sm};
    max-width: 900px;
  }
`;

export const MvvGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: ${SPACING.md};
  margin: ${SPACING.sm} 0;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    grid-template-columns: 1fr;
  }
`;

export const Mvv = styled.div`
  width: 50%;
  margin: 0 auto;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    width: 100%;
  }
`;